import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=0fba17b0&lang=pug&"
import script from "./CartItem.vue?vue&type=script&lang=js&"
export * from "./CartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports